import { useMemo } from "react";
import { UserConfigGetAPI } from "@/features/accountSettings/api/UserConfigAPI";
import type {
  AdditionalFieldConfig,
  AdditionalFieldItem,
} from "@/features/accountSettings/types/additionalFields";

/**
 * アカウント設定から追加項目の設定を取得するカスタムフック
 * deleted_at が null の項目のみをフィルタリングして返す
 */
export const useAdditionalFieldsConfig = (): {
  config: AdditionalFieldConfig | undefined;
  availableFields: AdditionalFieldConfig | undefined;
  hasAvailableFields: boolean;
} => {
  const userConfig = UserConfigGetAPI();
  const config = userConfig?.mapPlotRequestDetailAdditionalFields;

  // deletedAt が null または undefined の項目のみをフィルタリング（削除されていない項目）
  const availableFields = useMemo(() => {
    if (!config?.fields) return undefined;

    const filteredFields = config.fields.filter(
      (field: AdditionalFieldItem) => !field.deletedAt
    );

    return filteredFields.length > 0 ? { fields: filteredFields } : undefined;
  }, [config]);

  const hasAvailableFields = Boolean(
    availableFields?.fields && availableFields.fields.length > 0
  );

  return {
    config,
    availableFields,
    hasAvailableFields,
  };
};
